// Mirrors getApiUrl() in public/m.eagle/app/svc.js and service-worker.js: the legacy picks the API from the page hostname, so its token always belongs to that API.
const API_BY_HOST = [
	['localhost', 'https://apiv2.ecos.externis.net'],
	['m-dev', 'https://apiv2.ecos2.externis.net'],
	['m.ecos.externis.net', 'https://apiv2.ecos.externis.net'],
	['m.ecos2.externis.com', 'https://apiv2.ecos2.externis.com'],
];

export const resolveApiBaseUrl = (hostname, fallback = '') => API_BY_HOST.find(([key]) => hostname?.includes(key))?.[1] ?? fallback;

// svc.js urls.url_psp: the PSP application of the environment (an SSO handoff with ?a=PSPFO goes there).
const PSP_BY_HOST = [
	['localhost', 'https://localhost/psp'],
	['m-dev', 'https://m-dev.ecos.externis.net/psp'],
	['m.ecos.externis.net', 'https://ecos.externis.net/psp'],
	['m.ecos2.externis.com', 'https://ecos2.externis.com/psp'],
];

export const resolvePspUrl = (hostname) => PSP_BY_HOST.find(([key]) => hostname?.includes(key))?.[1] ?? null;
